module.exports = __webpack_public_path__ + "static/media/eg.22e10335.svg";